import React from 'react'; 
import trIcon from '../hybridImages/General-1px.png';
import inIcon from '../hybridImages/General-2.png';
import bankIcon from '../hybridImages/General-3.png'

const FinancingTypeExplanation = (props) => {

    return (
        <div className='fbaPSize tbl-bdr-shade'>
            <div className='tbl-finance-type-header'>
                <div className="row">
                    <div className="col-12">
                <div className='wd-35-pert item-float-left'>
                    Islamic Banking
                </div>
                <div className='wd-30-pert item-float-left'>
                    Key Differences
                </div>
                <div className='wd-35-pert item-float-left txt-left'>
                    Conventional Banking
                </div>
                    </div>
                </div>
            </div>
            <div className='tbl-finance-type-row bg-light-grey bdr-btm-line'>
                <div className="row">
                <div className="col-12">
                    <div className='wd-35-pert item-float-left txt-left'>
                        No interest or usury (riba), no uncertainty (gharar), and no gambling (maysir).
                    </div>
                    <div className='wd-30-pert item-float-left'>
                        <img className='wd-20-pert' src={trIcon} alt="trIcon1"></img>
                        <div className='fbaPWeight'>Transaction<br/>Restrictions</div>
                    </div>
                    <div className='wd-35-pert item-float-left txt-left'>
                        No such restrictions.
                    </div>
                </div>
                </div>
            </div>
            <div className='tbl-finance-type-row bdr-btm-line'>
                <div className="row">
                <div className="col-12">
                    <div className='wd-35-pert item-float-left txt-left'>
                        Profit-based (earned in exchange of goods)<br/>and fees.
                    </div>
                    <div className='wd-30-pert item-float-left'>
                        <img className='wd-20-pert' src={bankIcon} alt="trIcon1"></img>
                        <div className='fbaPWeight'>Income to the Bank</div>
                    </div>
                    <div className='wd-35-pert item-float-left txt-left'>
                        Interest-based<br/>(earned in lending transaction) and fees.
                    </div>
                </div>
                </div>
            </div>
            <div className='tbl-finance-type-row bg-light-grey'>
                <div className="row">
                    <div className="col-12">
                        <div className='wd-35-pert item-float-left txt-left'>
                            Charge compensation and penalty, with no compunding elements.
                        </div>
                        <div className='wd-30-pert item-float-left'>
                            <img className='wd-20-pert' src={inIcon} alt="trIcon1"></img>
                            <div className='fbaPWeight'>Penalties</div>
                        </div>
                        <div className='wd-35-pert item-float-left txt-left'>
                            Charge penalty interest, with compounding of interest.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FinancingTypeExplanation;